import { defineMessages } from 'react-intl'

export default defineMessages({
  nameIsRequired: {
    id: 'fertilizers.nameIsRequired',
    defaultMessage: 'Fertilizer name is required',
  },
  primaryNutrientsIsRequired: {
    id: 'fertilizers.primaryNutrientsIsRequired',
    defaultMessage: 'At least one primary nutrient must be set',
  },
  assetIsRequired: {
    id: 'fertilizers.assetIsRequired',
    defaultMessage: 'Fertilizer asset is required',
  },
  seasonIsRequired: {
    id: 'fertilizers.seasonIsRequired',
    defaultMessage: 'Fertilizer season is required',
  },
  usgallonspermtIsRequired: {
    id: 'fertilizers.usgallonspermtIsRequired',
    defaultMessage: 'US gallons per ton must be set for liquid fertilizers',
  },
  theFieldsAssetNameSeasonMustMakeAUniqueSet: {
    id: 'fertilizers.theFieldsAssetNameSeasonMustMakeAUniqueSet',
    defaultMessage: 'Fertilizer name already exists for the same asset and season',
  },
  rxNameIsTooLong: {
    id: 'fertilizers.rxNameIsTooLong',
    defaultMessage: 'Rx Name cannot exceed 4 characters',
  },
  rxNamesCannotStartWithAnUnderscoreOrDigit: {
    id: 'fertilizers.rxNamesCannotStartWithAnUnderscoreOrDigit',
    defaultMessage: 'Rx Name cannot start with underscore or digit',
  },
  'AddCustomBlend.nutrientValues': {
    id: 'AddCustomBlend.nutrientValues',
    defaultMessage: 'Nutrient Values',
  },
  'AddCustomBlend.primaryNutrients': {
    id: 'AddCustomBlend.primaryNutrients',
    defaultMessage: 'Primary Nutrients',
  },
  'AddCustomBlend.fertilizerName': {
    id: 'AddCustomBlend.fertilizerName',
    defaultMessage: 'Fertilizer name',
  },
  'AddCustomBlend.rxName': {
    id: 'AddCustomBlend.rxName',
    defaultMessage: 'Rx Name',
  },
  'AddCustomBlend.solidOrLiquid': {
    id: 'AddCustomBlend.solidOrLiquid',
    defaultMessage: 'Solid or Liquid',
  },
  'AddCustomBlend.solid': {
    id: 'AddCustomBlend.solid',
    defaultMessage: 'Solid',
  },
  'AddCustomBlend.liquid': {
    id: 'AddCustomBlend.liquid',
    defaultMessage: 'Liquid',
  },
  'AddCustomBlend.usGalPerUsTon': {
    id: 'AddCustomBlend.usGalPerUsTon',
    defaultMessage: 'US Gal per US Ton',
  },
  'AddCustomBlend.submit': {
    id: 'AddCustomBlend.submit',
    defaultMessage: 'Submit',
  },
  'AddCustomBlend.cancel': {
    id: 'AddCustomBlend.cancel',
    defaultMessage: 'Cancel',
  },
})
